import React, { useEffect, useState } from "react";
import play from "../../assets/icons/play.webp";
import CommonTitle from "../../components/CommonTitle";
import { IoAddOutline } from "react-icons/io5";
import TutorialCard from "../../components/tutorials/TutorialCard";
import ModalStructure from "../../components/ModalStructure";
import AddTutorialModal from "../../components/tutorials/AddTutorialModal";
import Pagination from "../../components/Pagination";
import { getTutorials, getTutorialsFiltered } from "../../services/tutorials";
import LoadingPage from "../../components/LoadingPage";
import Filters from "../../components/Filters";
import FilterItem from "../../components/FilterItem";
import { IS_LOCAL_ENV } from "../../App";
import Notification from "../../components/ui-elements/Notification";

const Tutorials = () => {
  const [loading, setLoading] = useState(true);
  const [tutorials, setTutorials] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [loadingFilter, setLoadingFilter] = useState(true);

  //=================table filters===========================

  const [selectPropsList, setSelectPropsList] = useState([
    {
      isInput: true,
      title: "Título del video",
      value: "",
      onChange: (e) => updateSelectProp(0, e),
      placeholder: "Buscar",
      inputType: "text",
      customMaxW: "max-w-[250px]",
      formatedValue: (val) => val,
      dbField: "title",
    },
    {
      options: [
        { text: "Crecimiento", value: "growth" },
        { text: "Floración", value: "flowering" },
        { text: "Descanso", value: "resting" },
        { text: "Cuidado", value: "care" },
        { text: "Alimentación", value: "feeding" },
        { text: "Cualquiera", value: "any" },
      ],
      title: "Categoría",
      value: "",
      setValue: (e) => updateSelectProp(1, e),
      formatedValue: (val) => val,
      dbField: "category",
    },
  ]);

  const updateSelectProp = (i, e) => {
    setSelectPropsList((prev) => {
      let temp = [...prev];
      temp[i].value = e.target.value;
      return temp;
    });
  };

  const [filterQueryObject, setFilterQueryObject] = useState({});

  //=========pagination props====================
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  //========================FetchData==========================
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getTutorialsFiltered(
          currentPage,
          filterQueryObject
        );
        if (!response?.docs || response.docs?.length === 0) {
          Notification({
            title: "Aviso",
            text: `Aún no hay tutoriales disponibles`,
            type: "Info",
          });
          setLoading(false);
          return;
        } else {
          setTutorials(response.docs);
          setTotalPages(response.totalPages);
          setLoading(false);
          setLoadingFilter(false);
        }
      } catch (err) {
        setLoading(false);
        setLoadingFilter(false);
        IS_LOCAL_ENV && console.error(err);
        Notification({
          title: "Error",
          text: `Algo salió mal...`,
          type: "Error",
        });
      }
    };
    fetchData();
  }, [currentPage, filterQueryObject]);

  //=======================addfilfunc==================
  const applyFilters = () => {
    let temp = [];

    temp = selectPropsList
      .filter((filter) => filter.value != "")
      .map((filter) => ({
        [filter.dbField]: {
          [filter.dbField === "category" ? "equals" : "like"]:
            filter.formatedValue(filter.value),
        },
      }));

    const filterQuery =
      temp.length > 1 ? { and: temp } : temp.length === 1 ? temp[0] : {};

    setFilterQueryObject(filterQuery);
  };
  //========================================================

  const onClickAdd = () => {
    setShowModal(true);
  };

  const addTutorial = (newObj) => {
    let tuts = [...tutorials];
    tuts.push(newObj);
    setTutorials(tuts);
  };

  const updateTutorialStatus = (i, status) => {
    let tuts = [...tutorials];
    tuts[i].status = status;
    setTutorials(tuts);
  };

  const handleDeleteVideo = async (id) => {
    let tuts = [...tutorials];
    tuts = tuts.filter((tut) => tut.id != id);
    setTutorials(tuts);
  };
  return (
    <>
      <div className="flex flex-col w-full justify-start h-full items-center relative">
        {showModal && (
          <ModalStructure handleCloseModal={() => setShowModal(false)}>
            <AddTutorialModal
              uploadParentArr={addTutorial}
              handleClose={() => setShowModal(false)}
            />
          </ModalStructure>
        )}
        <CommonTitle
          img={play}
          title="Tutoriales"
          text={
            "Podrás visualizar y añadir tutoriales para el cuidado de las orquídeas Phalaenopsis. "
          }
        >
          <button
            className={` w-fit bg-dark-green flex flex-row items-center gap-x-1 px-6 justify-center text-sm  rounded-full py-4  text-white hover:bg-accent-green transition-all duration-100 font-bold font-poppins `}
            onClick={onClickAdd}
          >
            <span className="text-nowrap">Nuevo Link</span>

            <IoAddOutline className="h-[20px] w-[20px]" />
          </button>
        </CommonTitle>
        {!loadingFilter && (
          <Filters applyFilters={applyFilters}>
            {selectPropsList.map((props, i) => {
              return <FilterItem props={props} key={i} />;
            })}
          </Filters>
        )}
        {loading ? (
          <LoadingPage />
        ) : (
          <div className="flex flex-col md:py-4 py-2 items-center w-full">
            <div className="flex w-full justify-center  p-4">
              <div className="flex flex-row flex-wrap max-w-[1680px]  w-full items-center justify-center md:p-6 p-1">
                {tutorials.map((tutorial, i) => {
                  return (
                    <div className="flex max-w-[400px] w-full">
                      <TutorialCard
                        removeFromParent={handleDeleteVideo}
                        tutorial={tutorial}
                        key={i}
                        index={i}
                        updateTutorialStatus={updateTutorialStatus}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalPages={totalPages}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default Tutorials;
